"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.version = exports.prerelease = exports.patch = exports.minor = exports.major = exports.default = void 0;
const version = exports.version = "6.4.10";
const major = exports.major = Number("6");
const minor = exports.minor = Number("4");
const patch = exports.patch = Number("10");
const prerelease = exports.prerelease = undefined;
var _default = exports.default = version;